<script>
</script>

<a
	class="
   mt-0 w-20 text-white
   md:-mt-4 md:w-30 md:text-indow-blue
 "
	href="/"
	aria-label="Home"
>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 517.64 184.64"
		preserveAspectRatio="xMinYMin meet"
		fill="currentColor"
	>
		<path
			d="M469.125 136.367l-11.56-41.846c-1.293-4.679-3.583-7.799-11.065-7.799s-10.004 4.008-11.38 8.602l-12.632 42.213-13.363-50.421H391.59l22.26 73.039h16.349l15.692-50.347 14.123 50.347h15.972l23.736-73.039h-16.785l-13.811 49.252m-262.932-51.34c-6.588 0-14.677 2.865-19.864 9.159v-7.073h-16.072v73.038h16.349v-39.58c0-12.492 3.053-15.521 4.879-17.328l.228-.232c4.473-4.477 10.24-4.701 11.352-4.701l.348.005c9.849 0 14.44 5.165 14.44 16.264v45.571h16.348v-49.887c0-24.021-23.331-25.237-28.008-25.237m72.247 64.897c-13.42 0-18.199-13.653-18.199-26.432 0-11.931 3.156-26.148 18.199-26.148 13.419 0 18.201 13.505 18.201 26.148 0 12.057-3.16 26.432-18.201 26.432zm34.407-3.728v-76.56c0-6.403-3.935-9.921-10.436-9.921h-5.909V93.3c-4.455-5.312-11.643-8.272-20.427-8.272-24.267 0-32.879 20.795-32.879 38.603s7.992 38.611 30.513 38.611c10.208 0 18.049-3.423 22.955-9.955l.023 7.865h16.16v-13.956"
		/>
		<path
			d="M356.534 149.504c-15.961 0-19.315-14.071-19.315-25.873s3.353-25.87 19.315-25.87c15.968 0 19.317 14.07 19.317 25.87s-3.349 25.873-19.317 25.873zm0-64.476c-22.424 0-36.357 14.792-36.357 38.603s13.933 38.611 36.357 38.611 36.36-14.795 36.36-38.611-13.933-38.603-36.36-38.603M157.62 59.715h-6.407c-5.769 0-9.947 3.297-9.947 9.256v9.028h16.353V59.715m-16.345 100.437h16.345V87.114h-16.345v73.038m369.193-66.916h-1.497v-1.867h1.205c1.167 0 1.516.215 1.516.818 0 .797-.271 1.049-1.224 1.049zm3.016-.875c0-1.808-1.188-2.392-3.248-2.392h-2.976v7.913h1.711v-3.245h.797l1.692 3.245h1.885l-1.828-3.422c1.109-.078 1.967-.642 1.967-2.1"
		/>
		<path
			d="M510.196 99.439c-2.92 0-5.235-2.234-5.235-5.503s2.315-5.503 5.235-5.503c2.857 0 5.229 2.235 5.229 5.503s-2.372 5.503-5.229 5.503zm0-12.718c-3.891 0-7.451 2.684-7.451 7.215s3.56 7.215 7.451 7.215 7.448-2.683 7.448-7.215-3.56-7.215-7.448-7.215m-499.792 58.8V14.364a3.65 3.65 0 0 1 3.651-3.652h61.27a3.65 3.65 0 0 1 3.651 3.652V24.47H32.249a9.13 9.13 0 0 0-9.13 9.128v115.574h-9.065a3.65 3.65 0 0 1-3.651-3.651zM81.147.006H9.13A9.13 9.13 0 0 0 0 9.135v141.913a9.13 9.13 0 0 0 9.13 9.128h72.017a9.13 9.13 0 0 0 9.13-9.128V9.135a9.13 9.13 0 0 0-9.13-9.129"
		/>
		<path
			d="M104.267 24.47h-5.183v132.409c0 7.209-7.545 13.127-14.464 13.127l-61.5.02c0 .022.002.045.002.068h-.002.001-.001v5.419c0 5.04 4.088 9.128 9.13 9.128h72.018c5.041 0 9.13-4.088 9.13-9.128V33.598a9.13 9.13 0 0 0-9.13-9.128"
		/>
	</svg>
</a>
